import fetch from '@/helpers/fetch'

export default {
	state: {
		clientsList: null,
		clientDetail: null,
		groupsList: null,
		groupsListAll: null,
		groupsAllSimpleList: null,

		alphabetList: null,

		elaborators: {},
		sales: {},
		reviewers: {},
	},
	mutations: {
		SET_CLIENTS_LIST(state, list) {
			state.clientsList = list
		},

		SET_CLIENT_DETAIL(state, clientDetail) {
			state.clientDetail = clientDetail
		},

		SET_GROUPS_SIMPLE_LIST(state, groups) {
			state.groupsAllSimpleList = groups
		},

		FILTER_GROUPS_LIST(state, filters) {
			// processGroups(state.groupsListAll, state, filters)
		},
	},
	actions: {
		fetchReport: async function (context): Promise<object[]> {
			const data = await fetch.get('/api/relatorio')

			context.commit('SET_GROUPS_LIST', data)

			return data
		},
		fetchGroupsSimple: async function (context): Promise<object[]> {
			const result = await fetch.get('/api/groups-simple')
			context.commit('SET_GROUPS_SIMPLE_LIST', result.data)
			return result.data
		},
		fetchClientDetail: async function (
			context,
			clientId: number,
		): Promise<object[]> {
			const data = await fetch.get('/api/groups/' + clientId)

			return data
		},
		filterGroups: function (context, filters) {
			context.commit('FILTER_GROUPS_LIST', filters)
		},
	},
}

function removeAccent(text) {
	text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'A')
	text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'E')
	text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'I')
	text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'O')
	text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'U')
	text = text.replace(new RegExp('[Ç]', 'gi'), 'C')
	return text
}
